import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import Select from 'react-select';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../../UseToken';
import Loader from '../../../Loader/Loader';
import Swal from 'sweetalert2'
import Hosts from '../../../../Hosts';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
} from '../../../../Utils';

import { language } from './Language';
import { color } from '../../../WEBContent/Color';

const modalStyles = {
	modalOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: color.corShadow.rgba2,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 1000,
	},
	modalContent: {
		backgroundColor: color.cor3.hexa,
		padding: '20px',
		borderRadius: '10px',
		width: '600px',
		maxWidth: '90%',
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative',
		overflow: 'hidden',
	},
	taskListContainer: {
		flex: 1,
		width: '100%',
		padding: '10px 15px',
		textAlign: 'start',
	},
	buttonContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		marginTop: '15px',
	},
	closeButton: {
		padding: '10px 20px',
		border: 'none',
		borderRadius: '5px',
		cursor: 'pointer',
		backgroundColor: color.cor1.hexa,
		fontSize: '16px',
	},
};

// Mesma lista de modalidades usada nos módulos das Competições / Convocatórias
const modalidades_lista = [
	{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
	{ value: 'curling', label: 'Curling' },
	{ value: 'ski_alpino', label: 'Esqui Alpino' },
	{ value: 'bobsled', label: 'Bobsled' },
	{ value: 'hoquei_no_gelo', label: 'Hóquei no Gelo' },
	{ value: 'luge', label: 'Luge' },
	{ value: 'snowboard', label: 'Snowboard' },
	{ value: 'skeleton', label: 'Skeleton' },
	{ value: 'patinagem_artistica', label: 'Patinagem Artística' },
	{ value: 'patinagem_de_velocidade', label: 'Patinagem de Velocidade' },
	{ value: 'ski_freestyle', label: 'Esqui Freestyle' },
	{ value: 'biatlo', label: 'Biatlo' },
];

let year = new Date().getFullYear();

// ================= TABELAS DE ESCALÃO (idênticas às Competições / Convocatórias) =================
const ESCALOES_GERAL = [
	{ id: 'U10', label: 'U10', min: (parseInt(year) - 9), max: Infinity },
	{ id: 'U12', label: 'U12', min: (parseInt(year) - 11), max: (parseInt(year) - 10) },
	{ id: 'U14', label: 'U14', min: (parseInt(year) - 13), max: (parseInt(year) - 12) },
	{ id: 'U16', label: 'U16', min: (parseInt(year) - 15), max: (parseInt(year) - 14) },
	{ id: 'U18', label: 'U18', min: (parseInt(year) - 17), max: (parseInt(year) - 16) },
	{ id: 'U21', label: 'U21', min: (parseInt(year) - 20), max: (parseInt(year) - 17) },
	{ id: 'SENIOR', label: 'Sénior', min: (parseInt(year) - 34), max: (parseInt(year) - 21) },
	{ id: 'M35', label: 'M35', min: (parseInt(year) - 54), max: (parseInt(year) - 35) },
	{ id: 'M55', label: 'M55', min: -Infinity, max: (parseInt(year) - 55) },
];

	const ESCALOES_SNOWBOARD = [
		{ id: 'U9', label: 'U9 (kids)', min: (parseInt(year) - 8), max: Infinity },
		{ id: 'U11', label: 'U11 (SuperGrom)', min: (parseInt(year) - 10), max: (parseInt(year) - 9) },
		{ id: 'U13', label: 'U13 (SuperGrom)', min: (parseInt(year) - 12), max: (parseInt(year) - 11) },
		{ id: 'U15', label: 'U15 (Grom)', min: (parseInt(year) - 14), max: (parseInt(year) - 13) },
		{ id: 'U18_ROOKIE', label: 'U18 (Rookie)', min: (parseInt(year) - 17), max: (parseInt(year) - 15) },
		{ id: 'ABSOLUTO', label: 'Absoluto', min: (parseInt(year) - 42), max: (parseInt(year) - 18) },
		{ id: 'M40', label: 'M40 (Master)', min: -Infinity, max: (parseInt(year) - 43) },
	];

const ESCALOES_PATINAGEM = [
	{ id: 'PRE_INICIADO', label: 'Pré-Iniciado' },
	{ id: 'NOVATOS', label: 'Novatos' },
	{ id: 'JUNIORES', label: 'Juniores' },
	{ id: 'SENIORES', label: 'Seniores' },
	{ id: 'ADULTOS', label: 'Adultos' },
];

const escaloes_lista = [
	...ESCALOES_GERAL.map(e => ({ value: e.id, label: e.label })),
	...ESCALOES_SNOWBOARD.map(e => ({ value: e.id, label: `${e.label} (Snowboard)` })),
	...ESCALOES_PATINAGEM.map(e => ({ value: e.id, label: `${e.label} (Patinagem)` })),
];

const tipo_competicao_lista = [
	{ value: 'nacional', label: 'Nacional' },
	{ value: 'internacional', label: 'Internacional' },
];

// Mesma lista usada no módulo das Convocatórias (info.tipo_convocatoria)
const tipo_convocatoria_lista = [
	{ value: 'competicao', label: 'Competição' },
	{ value: 'estagio', label: 'Estágio' },
	{ value: 'estagio_competicao', label: 'Estágio + Competição' },
];

const tipo_estagio_lista = [
	{ value: 'estagio', label: 'Estágio' },
	{ value: 'treino', label: 'Treino' },
	{ value: 'accao_preparacao', label: 'Ação de Preparação' },
];

const anoNascimento = (birthday) => {
	if (!birthday) return null;
	const ano = parseInt(String(birthday).slice(0, 4), 10);
	return Number.isNaN(ano) ? null : ano;
};

const escalaoPorAno = (ano, tabela) => {
	if (ano === null) return '';
	const item = tabela.find(e => ano >= e.min && ano <= e.max);
	return item ? item.id : '';
};

const idadeReferencia = (birthday, anoEpoca) => {
	if (!birthday) return null;
	const nascimento = new Date(birthday);
	const referencia = new Date(anoEpoca, 6, 1);
	let idade = referencia.getFullYear() - nascimento.getFullYear();
	const diffMes = referencia.getMonth() - nascimento.getMonth();
	if (diffMes < 0 || (diffMes === 0 && referencia.getDate() < nascimento.getDate())) idade--;
	return idade;
};

const escalaoPorIdade = (idade) => {
	if (idade === null) return '';
	if (idade >= 28) return 'ADULTOS';
	if (idade > 13 && idade <= 18) return 'JUNIORES';
	if (idade >= 8 && idade <= 13) return 'NOVATOS';
	if (idade >= 17) return 'SENIORES';
	if (idade >= 6) return 'PRE_INICIADO';
	return '';
};

const detectarGrupoModalidade = (modalidade_value) => {
	const v = (modalidade_value ?? '').toString().toLowerCase();
	if (v.includes('patinacao')) return 'patinagem';
	if (v.includes('snowboard')) return 'snowboard';
	return 'geral';
};

const getAnoEpocaAtual = () => {
	const hoje = new Date();
	const anoAtual = hoje.getFullYear();
	const mesAtual = hoje.getMonth();
	return mesAtual >= 6 ? anoAtual : anoAtual - 1;
};

const calcular_escalao_para_modalidade = (entidade, modalidade_value) => {
	const birthday = entidade?.info?.birthday ?? entidade?.birthday
	const grupo = detectarGrupoModalidade(modalidade_value)
	const anoEpoca = getAnoEpocaAtual()

	if (grupo === 'patinagem') {
		return escalaoPorIdade(idadeReferencia(birthday, anoEpoca))
	}
	const tabela = grupo === 'snowboard' ? ESCALOES_SNOWBOARD : ESCALOES_GERAL
	return escalaoPorAno(anoNascimento(birthday), tabela)
};

// Normaliza o campo "modalidades" da entidade (atleta). Suporta tanto o
// formato {value,label} (usado nos nossos módulos via react-select) como o
// formato {id,name} usado no módulo de Entidades/Atletas.
const get_entidade_modalidades_normalizadas = (entidade) => {
	const mods = entidade?.info?.modalidades ?? entidade?.modalidades
	if (!Array.isArray(mods)) return []
	return mods.map(m => {
		const value = m?.value ?? m?.id ?? m
		const label = m?.label ?? m?.name ?? ''
		return { value, label }
	}).filter(m => m.value)
};

const get_modalidades_entidade = (entidade) => get_entidade_modalidades_normalizadas(entidade).map(m => m.value);

const get_overlapping_modalidades = (entidade, modalidades_selecao) => {
	const mods_entidade = get_modalidades_entidade(entidade)
	if (!modalidades_selecao || modalidades_selecao.length === 0) return mods_entidade
	return mods_entidade.filter(m => modalidades_selecao.includes(m))
};

const entidade_pratica_modalidade = (entidade, modalidades_selecao) => {
	if (!modalidades_selecao || modalidades_selecao.length === 0) return true
	return get_overlapping_modalidades(entidade, modalidades_selecao).length > 0
};

// Normaliza o campo "clube" da entidade. Suporta objeto único {id,name} ou
// {id,label}, array de clubes, ou string simples.
const get_clube_label = (entidade) => {
	const clube = entidade?.info?.clube ?? entidade?.clube
	if (!clube) return ''
	if (typeof clube === 'string') return clube
	if (Array.isArray(clube)) {
		return clube.map(c => c?.label ?? c?.name ?? c).filter(Boolean).join(', ')
	}
	return clube?.label ?? clube?.name ?? ''
};

const get_modalidade_label = (value) => modalidades_lista.find(o => o.value === value)?.label ?? value ?? ''

// Junta os labels de um array de {label,value}, {name,id} (ou de strings) num só texto
const join_labels = (arr) => (Array.isArray(arr) ? arr.map(el => el?.label ?? el?.name ?? el).filter(Boolean).join(', ') : '') || '-';

// Categorias de "pessoas" da equipa técnica da seleção
const EQUIPA_TECNICA_CATEGORIES = {
	selecionador: { field: 'selecionador', label_key: 'Selecionador', title_key: 'selecionador' },
	treinadores: { field: 'treinadores', label_key: 'Treinadores', title_key: 'listagem_treinadores' },
	preparadores_fisicos: { field: 'preparadores_fisicos', label_key: 'Preparadores Físicos', title_key: 'listagem_preparadores_fisicos' },
	fisioterapeutas: { field: 'fisioterapeutas', label_key: 'Fisioterapeuta', title_key: 'listagem_fisioterapeutas' },
	outros: { field: 'outros', label_key: 'Outros', title_key: 'listagem_outros' },
};

const uid = () => `${Date.now()}_${Math.floor(Math.random() * 100000)}`;

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);
	const [is_edit, set_is_edit] = useState(false);

	// ===== Modal "Adicionar pessoa à equipa técnica" =====
	const [showPersonModal, setShowPersonModal] = useState(false);
	const [personCategory, setPersonCategory] = useState(null);
	const [personSearch, setPersonSearch] = useState('');
	const [personResults, setPersonResults] = useState([]);
	const [personLoading, setPersonLoading] = useState(false);
	const [selectedPerson, setSelectedPerson] = useState(null);

	const [clube_ids, set_clube_ids] = useState(new Set());

	const fetch_clube_ids = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			set_clube_ids(new Set((res.data || []).map(e => String(e.id))))
		} catch (error) {
			console.error('Erro ao carregar lista de clubes:', error)
		}
	}

	useEffect(() => {
		fetch_clube_ids()
	}, [])

	// ===== Todas as entidades (para preencher clube/modalidade/escalão/etc.
	// em tempo real nas tabelas de Atletas e Equipa Técnica, em vez de
	// depender apenas do que foi gravado no momento da inscrição) =====
	const [entidades_lista, set_entidades_lista] = useState([]);
	const entidades_by_id = useRef(new Map());

	const fetch_entidades_lista = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			const lista = res.data || []
			set_entidades_lista(lista)
			entidades_by_id.current = new Map(lista.map(e => [String(e.id), e]))
		} catch (error) {
			console.error('Erro ao carregar lista de entidades:', error)
		}
	}

	useEffect(() => {
		fetch_entidades_lista()
	}, [])

	const get_entidade_by_id = (id) => entidades_by_id.current.get(String(id))

	// ===== Modal "Inscrever Atletas" =====
	const [showAtletaModal, setShowAtletaModal] = useState(false);
	const [atletaSearch, setAtletaSearch] = useState('');
	const [atletaResults, setAtletaResults] = useState([]);
	const [atletaLoading, setAtletaLoading] = useState(false);
	const [selectedAtletaToInscrever, setSelectedAtletaToInscrever] = useState(null);

	// ===== Modal "Associar Convocatória" =====
	// (a lista completa é carregada logo no arranque, para conseguirmos
	// mostrar Modalidade / Escalão / Clube(s) / Nº Atletas na tabela,
	// mesmo sem o modal alguma vez ter sido aberto)
	const [showConvocatoriaModal, setShowConvocatoriaModal] = useState(false);
	const [convocatorias_lista, set_convocatorias_lista] = useState([]);
	const [convocatoriaLoading, setConvocatoriaLoading] = useState(false);
	const [selectedConvocatoria, setSelectedConvocatoria] = useState(null);
	const convocatorias_by_id = useRef(new Map());

	const fetch_convocatorias_lista = async () => {
		setConvocatoriaLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/intranet/components/type/${getTokenInfo().companycode}/convocatorias`)
			const lista = res.data || []
			set_convocatorias_lista(lista)
			convocatorias_by_id.current = new Map(lista.map(c => [String(c.id), c]))
		} catch (error) {
			console.error('Erro ao carregar lista de convocatórias:', error)
		} finally {
			setConvocatoriaLoading(false)
		}
	}

	useEffect(() => {
		fetch_convocatorias_lista()
	}, [])

	const get_convocatoria_by_id = (id) => convocatorias_by_id.current.get(String(id))

	useEffect(() => {
		if (showConvocatoriaModal) fetch_convocatorias_lista()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showConvocatoriaModal])

	// ===== Formulários inline: Calendário de Estágios/Treinos =====
	const estagio_form_default = { tipo: 'estagio', designacao: '', local: '', localidade: '', pais: '', data_inicio: '', data_fim: '' };
	const [estagioForm, setEstagioForm] = useState(estagio_form_default);

	// ===== Formulários inline: Calendário de Competições =====
	const competicao_form_default = { tipo: 'nacional', designacao: '', local: '', localidade: '', pais: '', data_inicio: '', data_fim: '' };
	const [competicaoForm, setCompeticaoForm] = useState(competicao_form_default);

	// ===== Formulário inline: Histórico da Seleção =====
	const historico_form_default = { epoca: '', modalidade: '', escalao: '', competicoes: '', resultados: '' };
	const [historicoForm, setHistoricoForm] = useState(historico_form_default);

	// Garante que todos os campos usados pelo formulário existem, mesmo que o
	// data_interface do Config.js ainda não os tenha definidos.
	const ensure_defaults = (d) => {
		const info_defaults = {
			name: '',
			modalidades: [],
			escaloes: [],
			epoca: '',
			equipa_tecnica: {
				selecionador: [],
				treinadores: [],
				preparadores_fisicos: [],
				fisioterapeutas: [],
				outros: [],
			},
			calendario_estagios_treinos: [],
			calendario_competicoes: [],
			atletas_inscritos: [],
			convocatorias_associadas: [],
			historico: [],
			observacoes: '',
		}
		d.info = { ...info_defaults, ...d.info }
		Object.keys(info_defaults).forEach(k => {
			if (d.info[k] === null || d.info[k] === undefined) {
				d.info[k] = info_defaults[k]
			}
		})

		d.info.equipa_tecnica = { ...info_defaults.equipa_tecnica, ...(d.info.equipa_tecnica || {}) }
		Object.keys(info_defaults.equipa_tecnica).forEach(k => {
			if (!Array.isArray(d.info.equipa_tecnica[k])) d.info.equipa_tecnica[k] = []
		})

		return d
	}

	const clean_data = () => {
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current = ensure_defaults(dados.current))
	}

	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = ensure_defaults(res.data[0]));
			})
			.catch(error => console.log(error))
	}

	const item_id = props?.location?.state?.item?.id
	const operation = props?.location?.state?.operation

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		if (operation === 'edit' && item_id) {
			set_is_edit(true)
			set_show_delete_button(true)

			fetch_id_info(item_id).then(() => {
				setLoading(false)
			})
			return
		}

		clean_data()
		setLoading(false);
		setRedirect(false);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_id, operation])

	const handle_change_info = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info[name] = value)
	}

	const change_modalidades = (selected) => {
		set_dados(dados.current.info.modalidades = selected || []);
	};

	const change_escaloes = (selected) => {
		set_dados(dados.current.info.escaloes = selected || []);
	};

	// ================= EQUIPA TÉCNICA (pesquisa de pessoas) =================
	const search_person = async (term) => {
		if (!personCategory) return
		setPersonLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			const t = (term || '').toLowerCase()
			const field = EQUIPA_TECNICA_CATEGORIES[personCategory].field
			const ja_inscritos = (dados.current.info.equipa_tecnica[field] || []).map(p => String(p.id))

			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => !clube_ids.has(String(e.id)))
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})

			setPersonResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar:', error)
		} finally {
			setPersonLoading(false)
		}
	}

	useEffect(() => {
		if (showPersonModal) {
			search_person(personSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showPersonModal, personCategory])

	const openPersonModal = (category) => {
		setPersonCategory(category)
		setPersonSearch('')
		setSelectedPerson(null)
		setShowPersonModal(true)
	}

	const handle_person_search_change = (e) => {
		const value = e.target.value
		setPersonSearch(value)
		search_person(value)
	}

	const handleClosePersonModal = () => {
		setShowPersonModal(false)
		setPersonCategory(null)
		setSelectedPerson(null)
		setPersonSearch('')
	}

	const adicionar_person = () => {
		if (!selectedPerson || !personCategory) return

		const nome = selectedPerson?.info?.name ?? selectedPerson?.name ?? ''
		const field = EQUIPA_TECNICA_CATEGORIES[personCategory].field

		Swal.fire({
			title: language[lang].inscrever_pessoa_title ?? 'Adicionar',
			html: `${language[lang].inscrever_pessoa_text ?? 'Confirma adicionar'} <b>${nome}</b> ${language[lang].inscrever_selecao_text_2 ?? 'à equipa técnica desta seleção?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Adicionar',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const atual = dados.current.info.equipa_tecnica[field] || []
				set_dados(dados.current.info.equipa_tecnica[field] = [...atual, { id: selectedPerson.id, label: nome }])
				handleClosePersonModal()
			}
		})
	}

	const remover_person = (category, person_id) => {
		const field = EQUIPA_TECNICA_CATEGORIES[category].field
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este registo da seleção?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				set_dados(dados.current.info.equipa_tecnica[field] = (dados.current.info.equipa_tecnica[field] || []).filter(p => String(p.id) !== String(person_id)))
			}
		})
	}

	// ================= ATLETAS INSCRITOS NA SELEÇÃO =================
	const search_atletas_to_inscrever = async (term) => {
		setAtletaLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			const t = (term || '').toLowerCase()
			const ja_inscritos = (dados.current.info.atletas_inscritos || []).map(a => String(a.id))
			const modalidades_selecao = dados.current.info.modalidades || []

			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => !clube_ids.has(String(e.id)))
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})
				.filter(e => entidade_pratica_modalidade(e, modalidades_selecao.map(m => m.value ?? m)))

			setAtletaResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar atletas:', error)
		} finally {
			setAtletaLoading(false)
		}
	}

	useEffect(() => {
		if (showAtletaModal) {
			search_atletas_to_inscrever(atletaSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showAtletaModal])

	const handle_atleta_search_change = (e) => {
		const value = e.target.value
		setAtletaSearch(value)
		search_atletas_to_inscrever(value)
	}

	const handleCloseAtletaModal = () => {
		setShowAtletaModal(false)
		setSelectedAtletaToInscrever(null)
		setAtletaSearch('')
	}

	const inscrever_atleta = () => {
		if (!selectedAtletaToInscrever) return

		const nome_atleta = selectedAtletaToInscrever?.info?.name ?? selectedAtletaToInscrever?.name ?? ''
		const numero_atleta = selectedAtletaToInscrever?.info?.numero_atleta ?? selectedAtletaToInscrever?.numero_atleta ?? ''
		const clube_atleta = get_clube_label(selectedAtletaToInscrever)
		const modalidades_selecao = (dados.current.info.modalidades || []).map(m => m.value ?? m)
		const overlapping = get_overlapping_modalidades(selectedAtletaToInscrever, modalidades_selecao)
		const entidade_mods = get_entidade_modalidades_normalizadas(selectedAtletaToInscrever)

		// Escalão do atleta calculado por cada modalidade em comum com a seleção
		// (ex: "Esqui Alpino: U16, Snowboard: U15")
		const modalidades_label = overlapping
			.map(v => entidade_mods.find(m => m.value === v)?.label || get_modalidade_label(v))
			.join(', ') || '-'
		const escalao_atleta = calcular_escalao_para_modalidade(selectedAtletaToInscrever, overlapping[0])
		const escaloes_detalhe = overlapping
			.map(v => {
				const escalao_valor = calcular_escalao_para_modalidade(selectedAtletaToInscrever, v)
				const escalao_label = escaloes_lista.find(o => o.value === escalao_valor)?.label ?? escalao_valor
				const modalidade_label = entidade_mods.find(m => m.value === v)?.label || get_modalidade_label(v)
				return escalao_label ? `${modalidade_label}: ${escalao_label}` : ''
			})
			.filter(Boolean)
			.join(', ') || '-'

		Swal.fire({
			title: language[lang].inscrever_atleta_title ?? 'Inscrever atleta',
			html: `${language[lang].inscrever_atleta_text ?? 'Confirma inscrever o atleta'} <b>${nome_atleta}</b> ${language[lang].inscrever_selecao_text_2 ?? 'nesta seleção?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Inscrever',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const atual = dados.current.info.atletas_inscritos || []
				set_dados(dados.current.info.atletas_inscritos = [
					...atual,
					{
						id: selectedAtletaToInscrever.id,
						label: nome_atleta,
						numero_atleta: numero_atleta,
						clube: clube_atleta,
						modalidades: modalidades_label,
						escalao: escalao_atleta,
						escaloes_detalhe: escaloes_detalhe,
					}
				])
				handleCloseAtletaModal()
			}
		})
	}

	const remover_atleta_inscrito = (atleta_id) => {
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este atleta da seleção?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				set_dados(dados.current.info.atletas_inscritos = (dados.current.info.atletas_inscritos || []).filter(a => String(a.id) !== String(atleta_id)))
			}
		})
	}

	// Junta o snapshot gravado na inscrição com os dados ATUAIS da entidade
	// (nome, clube, modalidades, nacionalidade, data de nascimento, contacto),
	// para a tabela mostrar sempre a informação mais completa possível.
	const get_atleta_display = (el) => {
		const entidade = get_entidade_by_id(el.id)
		const modalidades_selecao = (dados.current.info.modalidades || []).map(m => m.value ?? m)

		if (!entidade) {
			// Entidade ainda não carregada (ou foi entretanto removida) — usa o snapshot
			return {
				numero_atleta: el.numero_atleta || '-',
				nome: el.label || '-',
				clube: el.clube || '-',
				modalidades: el.modalidades || '-',
				escaloes: el.escaloes_detalhe || el.escalao || '-',
				nacionalidade: '-',
				data_nascimento: '-',
				contacto: '-',
			}
		}

		const overlapping = get_overlapping_modalidades(entidade, modalidades_selecao)
		const entidade_mods = get_entidade_modalidades_normalizadas(entidade)
		const modalidades_label = overlapping.length > 0
			? overlapping.map(v => entidade_mods.find(m => m.value === v)?.label || get_modalidade_label(v)).join(', ')
			: (entidade_mods.map(m => m.label || get_modalidade_label(m.value)).join(', ') || '-')
		const escaloes_label = (overlapping.length > 0 ? overlapping : entidade_mods.map(m => m.value))
			.map(v => {
				const escalao_valor = calcular_escalao_para_modalidade(entidade, v)
				const escalao_label = escaloes_lista.find(o => o.value === escalao_valor)?.label ?? escalao_valor
				const modalidade_label = entidade_mods.find(m => m.value === v)?.label || get_modalidade_label(v)
				return escalao_label ? `${modalidade_label}: ${escalao_label}` : ''
			})
			.filter(Boolean)
			.join(', ') || '-'

		return {
			numero_atleta: entidade?.info?.numero_atleta ?? entidade?.numero_atleta ?? el.numero_atleta ?? '-',
			nome: entidade?.info?.name ?? entidade?.name ?? el.label ?? '-',
			clube: get_clube_label(entidade) || el.clube || '-',
			modalidades: modalidades_label || el.modalidades || '-',
			escaloes: escaloes_label !== '-' ? escaloes_label : (el.escaloes_detalhe || el.escalao || '-'),
			nacionalidade: entidade?.info?.nacionalidade ?? '-',
			data_nascimento: entidade?.info?.birthday ?? '-',
			contacto: entidade?.info?.email ?? entidade?.info?.telefone ?? '-',
		}
	}

	// ================= CONVOCATÓRIAS ASSOCIADAS À SELEÇÃO =================
	const handle_close_convocatoria_modal = () => {
		setShowConvocatoriaModal(false)
		setSelectedConvocatoria(null)
	}

	const associar_convocatoria = () => {
		if (!selectedConvocatoria) return
		const nome = selectedConvocatoria?.info?.name ?? selectedConvocatoria?.name ?? ''
		const modalidade_label = get_modalidade_label(selectedConvocatoria?.info?.modalidade)
		const escaloes_label = join_labels(selectedConvocatoria?.info?.escaloes)
		const clubes_label = join_labels(selectedConvocatoria?.info?.clubes_inscritos)
		const n_atletas = (selectedConvocatoria?.info?.atletas_inscritos || []).length

		Swal.fire({
			title: language[lang].associar_convocatoria_title ?? 'Associar convocatória',
			html: `${language[lang].associar_convocatoria_text ?? 'Confirma associar a convocatória'} <b>${nome}</b> ${language[lang].inscrever_selecao_text_2 ?? 'a esta seleção?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Associar',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const atual = dados.current.info.convocatorias_associadas || []
				set_dados(dados.current.info.convocatorias_associadas = [
					...atual,
					{
						id: selectedConvocatoria.id,
						label: nome,
						modalidade: modalidade_label,
						escaloes: escaloes_label,
						clubes: clubes_label,
						n_atletas: n_atletas,
					}
				])
				handle_close_convocatoria_modal()
			}
		})
	}

	const remover_convocatoria_associada = (id) => {
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma desassociar esta convocatória da seleção?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				set_dados(dados.current.info.convocatorias_associadas = (dados.current.info.convocatorias_associadas || []).filter(c => String(c.id) !== String(id)))
			}
		})
	}

	// Junta o snapshot gravado na associação com os dados ATUAIS da convocatória
	// (competição associada, tipo, modalidade, escalões, época, clubes, nº de
	// atletas), para a tabela mostrar sempre a informação mais completa possível.
	const get_convocatoria_display = (el) => {
		const convocatoria = get_convocatoria_by_id(el.id)

		if (!convocatoria) {
			// Convocatória ainda não carregada (ou foi entretanto eliminada) — usa o snapshot
			return {
				nome: el.label || '-',
				competicao: '-',
				tipo: '-',
				modalidade: el.modalidade || '-',
				escaloes: el.escaloes || '-',
				epoca: '-',
				clubes: el.clubes || '-',
				n_atletas: el.n_atletas ?? 0,
			}
		}

		const info = convocatoria.info || {}
		return {
			nome: info.name ?? el.label ?? '-',
			competicao: info.competicao_label || '-',
			tipo: tipo_convocatoria_lista.find(t => t.value === info.tipo_convocatoria)?.label ?? '-',
			modalidade: get_modalidade_label(info.modalidade) || el.modalidade || '-',
			escaloes: join_labels(info.escaloes) !== '-' ? join_labels(info.escaloes) : (el.escaloes || '-'),
			epoca: info.epoca || '-',
			clubes: join_labels(info.clubes_inscritos) !== '-' ? join_labels(info.clubes_inscritos) : (el.clubes || '-'),
			n_atletas: (info.atletas_inscritos || []).length,
		}
	}

	const convocatorias_disponiveis = convocatorias_lista.filter(c => {
		const ja_associada = (dados.current?.info?.convocatorias_associadas || []).map(a => String(a.id))
		return !ja_associada.includes(String(c.id))
	})

	// ================= CALENDÁRIO DE ESTÁGIOS / TREINOS =================
	const handle_estagio_form_change = (e) => {
		const { name, value } = e.target
		setEstagioForm(prev => ({ ...prev, [name]: value }))
	}

	const change_estagio_tipo = (selected) => {
		setEstagioForm(prev => ({ ...prev, tipo: selected ? selected.value : 'estagio' }))
	}

	const adicionar_estagio = () => {
		if (!estagioForm.designacao) {
			Swal.fire(language[lang].campo_obrigatorio ?? 'Indique uma designação.', '', 'info')
			return
		}
		const atual = dados.current.info.calendario_estagios_treinos || []
		set_dados(dados.current.info.calendario_estagios_treinos = [...atual, { ...estagioForm, id: uid() }])
		setEstagioForm(estagio_form_default)
	}

	const remover_estagio = (id) => {
		set_dados(dados.current.info.calendario_estagios_treinos = (dados.current.info.calendario_estagios_treinos || []).filter(e => String(e.id) !== String(id)))
	}

	// ================= CALENDÁRIO DE COMPETIÇÕES NACIONAIS / INTERNACIONAIS =================
	const handle_competicao_form_change = (e) => {
		const { name, value } = e.target
		setCompeticaoForm(prev => ({ ...prev, [name]: value }))
	}

	const change_competicao_tipo = (selected) => {
		setCompeticaoForm(prev => ({ ...prev, tipo: selected ? selected.value : 'nacional' }))
	}

	const adicionar_competicao = () => {
		if (!competicaoForm.designacao) {
			Swal.fire(language[lang].campo_obrigatorio ?? 'Indique uma designação.', '', 'info')
			return
		}
		const atual = dados.current.info.calendario_competicoes || []
		set_dados(dados.current.info.calendario_competicoes = [...atual, { ...competicaoForm, id: uid() }])
		setCompeticaoForm(competicao_form_default)
	}

	const remover_competicao = (id) => {
		set_dados(dados.current.info.calendario_competicoes = (dados.current.info.calendario_competicoes || []).filter(c => String(c.id) !== String(id)))
	}

	// ================= HISTÓRICO DA SELEÇÃO =================
	const handle_historico_form_change = (e) => {
		const { name, value } = e.target
		setHistoricoForm(prev => ({ ...prev, [name]: value }))
	}

	const adicionar_historico = () => {
		if (!historicoForm.epoca) {
			Swal.fire(language[lang].campo_obrigatorio ?? 'Indique a época.', '', 'info')
			return
		}
		const atual = dados.current.info.historico || []
		set_dados(dados.current.info.historico = [...atual, { ...historicoForm, id: uid() }])
		setHistoricoForm(historico_form_default)
	}

	const remover_historico = (id) => {
		set_dados(dados.current.info.historico = (dados.current.info.historico || []).filter(h => String(h.id) !== String(id)))
	}

	// ================= GRAVAR / ELIMINAR =================
	const handleSubmit = async (e) => {
		e.preventDefault();

		Swal.fire({
			title: is_edit ? (language[lang].edit_title ?? 'Editar') : (language[lang].insert_title ?? 'Inserir'),
			text: is_edit ? (language[lang].edit_text ?? 'Confirma a edição?') : (language[lang].insert_text ?? 'Confirma a inserção?'),
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: is_edit ? (language[lang].edit_confirm ?? 'Confirmar') : (language[lang].insert_confirm ?? 'Confirmar'),
			cancelButtonText: is_edit ? (language[lang].edit_cancel ?? 'Cancelar') : (language[lang].insert_cancel ?? 'Cancelar')
		}).then((result) => {
			if (result.isConfirmed) {

				const requestMethod = is_edit ? reqPUT : reqPOST

				requestMethod(`${api_crud_route}`, dados.current)
					.then(() => {
						props.history.push(endpoints.list)
					})
					.catch(() => Swal.fire(is_edit ? (language[lang].edit_error ?? 'Erro ao editar') : (language[lang].insert_error ?? 'Erro ao inserir'), '', 'info'))
			}
		})
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title ?? 'Eliminar',
			text: language[lang].delete_text ?? 'Confirma a eliminação?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm ?? 'Eliminar',
			cancelButtonText: language[lang].delete_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => { props.history.push(endpoints.list); })
					.catch(() => Swal.fire(language[lang].delete_error ?? 'Erro ao eliminar', '', 'info'))
			}
		})
	};

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].selecao ?? 'Seleção'}</h2>
					<p>{language[lang].selecao ?? 'Seleção'} / {dados.current.id !== '' ? (language[lang].entity_edit ?? 'Editar') : (language[lang].entity_new ?? 'Novo')}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">

								{/* --- Dados da Seleção --- */}
								<div className="card">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].dados_selecao ?? 'Dados da Seleção'}</h3>
										</div>
									</div>
									<div className="collapse show">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">

												<div className="row g-3 mb-4">
													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].selecao ?? 'Seleção'}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control rounded-0" placeholder={language[lang].selecao_placeholder ?? 'Nome da seleção'} onChange={handle_change_info} required />
													</div>

													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].epoca ?? 'Época'}</label>
														<input type="text" name="epoca" value={dados.current.info.epoca} className="form-control rounded-0" placeholder="2025/2026" onChange={handle_change_info} />
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].modalidades ?? 'Modalidade(s)'}</label>
														<Select
															isMulti
															className="div-select"
															options={modalidades_lista}
															value={
																Array.isArray(dados.current.info.modalidades)
																	? dados.current.info.modalidades.map(m => ({ label: m.label ?? m, value: m.value ?? m }))
																	: []
															}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_modalidades}
														/>
													</div>

													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].escaloes ?? 'Escalão(ões)'}</label>
														<Select
															isMulti
															className="div-select"
															options={escaloes_lista}
															value={
																Array.isArray(dados.current.info.escaloes)
																	? dados.current.info.escaloes.map(m => ({ label: m.label ?? m, value: m.value ?? m }))
																	: []
															}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_escaloes}
														/>
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-12">
														<label className="form-label fw-bold fs-6">{language[lang].observacoes ?? 'Observações'}</label>
														<textarea name="observacoes" value={dados.current.info.observacoes} className="form-control rounded-0" rows="3" onChange={handle_change_info} />
													</div>
												</div>

											</div>
										</form>
									</div>
								</div>

								{/* --- Equipa Técnica --- */}
								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].equipa_tecnica ?? 'Equipa Técnica'}</h3>
										</div>
									</div>
									<div className="card-body border-top p-4">
										<div className="row g-3">
											{Object.entries(EQUIPA_TECNICA_CATEGORIES).map(([cat, cfg]) => (
												<div className="col-md-6" key={cat}>
													<EquipaTecnicaCard
														category={cat}
														config={cfg}
														items={dados.current.info.equipa_tecnica[cfg.field] || []}
														language={language}
														lang={lang}
														onAdd={() => openPersonModal(cat)}
														onRemove={(id) => remover_person(cat, id)}
													/>
												</div>
											))}
										</div>
									</div>
								</div>

								{/* --- Calendário de Estágios e Treinos (inclui ações de preparação) --- */}
								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].calendario_estagios_treinos ?? 'Calendário de Estágios, Treinos e Ações de Preparação'}</h3>
										</div>
									</div>
									<div className="card-body border-top p-4">
										<div className="row g-3 mb-3 align-items-end">
											<div className="col-md-2">
												<label className="form-label fw-bold fs-6">{language[lang].tipo ?? 'Tipo'}</label>
												<Select
													className="div-select"
													options={tipo_estagio_lista}
													value={tipo_estagio_lista.find(o => o.value === estagioForm.tipo) ?? null}
													onChange={change_estagio_tipo}
												/>
											</div>
											<div className="col-md-3">
												<label className="form-label fw-bold fs-6">{language[lang].designacao ?? 'Designação'}</label>
												<input type="text" name="designacao" value={estagioForm.designacao} className="form-control rounded-0" onChange={handle_estagio_form_change} />
											</div>
											<div className="col-md-2">
												<label className="form-label fw-bold fs-6">{language[lang].localidade_estagio ?? 'Localidade'}</label>
												<input type="text" name="localidade" value={estagioForm.localidade} className="form-control rounded-0" onChange={handle_estagio_form_change} />
											</div>
											<div className="col-md-2">
												<label className="form-label fw-bold fs-6">{language[lang].data_saida ?? 'Data início'}</label>
												<input type="date" name="data_inicio" value={estagioForm.data_inicio} className="form-control rounded-0" onChange={handle_estagio_form_change} />
											</div>
											<div className="col-md-2">
												<label className="form-label fw-bold fs-6">{language[lang].fim ?? 'Data fim'}</label>
												<input type="date" name="data_fim" value={estagioForm.data_fim} className="form-control rounded-0" onChange={handle_estagio_form_change} />
											</div>
											<div className="col-md-1">
												<button type="button" className="btn btn-primary w-100" onClick={adicionar_estagio}>
													<i className="bi bi-plus-lg"></i>
												</button>
											</div>
										</div>

										<table className="table table-bordered align-middle">
											<thead>
												<tr>
													<th>{language[lang].tipo ?? 'Tipo'}</th>
													<th>{language[lang].designacao ?? 'Designação'}</th>
													<th>{language[lang].localidade_estagio ?? 'Localidade'}</th>
													<th>{language[lang].data_saida ?? 'Início'}</th>
													<th>{language[lang].fim ?? 'Fim'}</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												{(dados.current.info.calendario_estagios_treinos || []).length > 0 ? (
													dados.current.info.calendario_estagios_treinos.map((el) => (
														<tr key={el.id}>
															<td>{tipo_estagio_lista.find(t => t.value === el.tipo)?.label ?? el.tipo}</td>
															<td>{el.designacao}</td>
															<td>{el.localidade}{el.pais ? `, ${el.pais}` : ''}</td>
															<td>{el.data_inicio}</td>
															<td>{el.data_fim}</td>
															<td className="text-end">
																<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => remover_estagio(el.id)}>
																	{language[lang].remove ?? 'Remover'}
																</button>
															</td>
														</tr>
													))
												) : (
													<tr>
														<td colSpan="6" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								</div>

								{/* --- Calendário de Competições Nacionais e Internacionais --- */}
								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].calendario_competicoes ?? 'Calendário de Competições Nacionais e Internacionais'}</h3>
										</div>
									</div>
									<div className="card-body border-top p-4">
										<div className="row g-3 mb-3 align-items-end">
											<div className="col-md-2">
												<label className="form-label fw-bold fs-6">{language[lang].tipo ?? 'Tipo'}</label>
												<Select
													className="div-select"
													options={tipo_competicao_lista}
													value={tipo_competicao_lista.find(o => o.value === competicaoForm.tipo) ?? null}
													onChange={change_competicao_tipo}
												/>
											</div>
											<div className="col-md-3">
												<label className="form-label fw-bold fs-6">{language[lang].designacao ?? 'Designação'}</label>
												<input type="text" name="designacao" value={competicaoForm.designacao} className="form-control rounded-0" onChange={handle_competicao_form_change} />
											</div>
											<div className="col-md-2">
												<label className="form-label fw-bold fs-6">{language[lang].country ?? 'País'}</label>
												<input type="text" name="pais" value={competicaoForm.pais} className="form-control rounded-0" onChange={handle_competicao_form_change} />
											</div>
											<div className="col-md-2">
												<label className="form-label fw-bold fs-6">{language[lang].data_saida ?? 'Data início'}</label>
												<input type="date" name="data_inicio" value={competicaoForm.data_inicio} className="form-control rounded-0" onChange={handle_competicao_form_change} />
											</div>
											<div className="col-md-2">
												<label className="form-label fw-bold fs-6">{language[lang].fim ?? 'Data fim'}</label>
												<input type="date" name="data_fim" value={competicaoForm.data_fim} className="form-control rounded-0" onChange={handle_competicao_form_change} />
											</div>
											<div className="col-md-1">
												<button type="button" className="btn btn-primary w-100" onClick={adicionar_competicao}>
													<i className="bi bi-plus-lg"></i>
												</button>
											</div>
										</div>

										<table className="table table-bordered align-middle">
											<thead>
												<tr>
													<th>{language[lang].tipo ?? 'Tipo'}</th>
													<th>{language[lang].designacao ?? 'Designação'}</th>
													<th>{language[lang].country ?? 'País'}</th>
													<th>{language[lang].data_saida ?? 'Início'}</th>
													<th>{language[lang].fim ?? 'Fim'}</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												{(dados.current.info.calendario_competicoes || []).length > 0 ? (
													dados.current.info.calendario_competicoes.map((el) => (
														<tr key={el.id}>
															<td>{tipo_competicao_lista.find(t => t.value === el.tipo)?.label ?? el.tipo}</td>
															<td>{el.designacao}</td>
															<td>{el.pais}</td>
															<td>{el.data_inicio}</td>
															<td>{el.data_fim}</td>
															<td className="text-end">
																<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => remover_competicao(el.id)}>
																	{language[lang].remove ?? 'Remover'}
																</button>
															</td>
														</tr>
													))
												) : (
													<tr>
														<td colSpan="6" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								</div>

								{is_edit && (
								<>
									{/* --- Lista de Atletas por Seleção --- */}
									<div className="card mt-5">
										<div className="card-header border-0 d-flex justify-content-between align-items-center">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].atletas_por_selecao ?? 'Lista de Atletas por Seleção'}</h3>
											</div>
											<button type="button" className="btn btn-sm btn-primary" onClick={() => setShowAtletaModal(true)}>
												<i className="bi bi-plus-circle me-2"></i>
												{language[lang].inscrever_atletas ?? 'Inscrever Atletas'}
											</button>
										</div>
										<div className="card-body border-top p-4">
											<table className="table table-bordered align-middle">
												<thead>
													<tr>
														<th>{language[lang].numero_atleta ?? 'Nº de Atleta'}</th>
														<th>{language[lang].name ?? 'Nome'}</th>
														<th>{language[lang].clube ?? 'Clube'}</th>
														<th>{language[lang].modalidades ?? 'Modalidade(s)'}</th>
														<th>{language[lang].escaloes ?? 'Escalão(ões)'}</th>
														<th>{language[lang].data_nascimento ?? 'Data Nasc.'}</th>
														<th>{language[lang].nacionalidade ?? 'Nacionalidade'}</th>
														<th>{language[lang].contacto ?? 'Contacto'}</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{(dados.current.info.atletas_inscritos || []).length > 0 ? (
														dados.current.info.atletas_inscritos.map((el, k) => {
															const d = get_atleta_display(el)
															return (
																<tr key={el.id ?? k}>
																	<td>{d.numero_atleta}</td>
																	<td>{d.nome}</td>
																	<td>{d.clube}</td>
																	<td>{d.modalidades}</td>
																	<td>{d.escaloes}</td>
																	<td>{d.data_nascimento}</td>
																	<td>{d.nacionalidade}</td>
																	<td>{d.contacto}</td>
																	<td className="text-end">
																		<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => remover_atleta_inscrito(el.id)}>
																			{language[lang].remove ?? 'Remover'}
																		</button>
																	</td>
																</tr>
															)
														})
													) : (
														<tr>
															<td colSpan="9" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
														</tr>
													)}
												</tbody>
											</table>
										</div>
									</div>

									{/* --- Lista de Convocatórias por Seleção --- */}
									<div className="card mt-5">
										<div className="card-header border-0 d-flex justify-content-between align-items-center">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].convocatorias_por_selecao ?? 'Lista de Convocatórias por Seleção'}</h3>
											</div>
											<button type="button" className="btn btn-sm btn-primary" onClick={() => setShowConvocatoriaModal(true)}>
												<i className="bi bi-plus-circle me-2"></i>
												{language[lang].associar_convocatoria ?? 'Associar Convocatória'}
											</button>
										</div>
										<div className="card-body border-top p-4">
											<table className="table table-bordered align-middle">
												<thead>
													<tr>
														<th>{language[lang].convocatoria ?? 'Convocatória'}</th>
														<th>{language[lang].competicao ?? 'Competição'}</th>
														<th>{language[lang].tipo ?? 'Tipo'}</th>
														<th>{language[lang].modalidade ?? 'Modalidade'}</th>
														<th>{language[lang].escaloes ?? 'Escalão(ões)'}</th>
														<th>{language[lang].epoca ?? 'Época'}</th>
														<th>{language[lang].clube ?? 'Clube(s)'}</th>
														<th>{language[lang].n_atletas ?? 'Nº Atletas'}</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{(dados.current.info.convocatorias_associadas || []).length > 0 ? (
														dados.current.info.convocatorias_associadas.map((el, k) => {
															const d = get_convocatoria_display(el)
															return (
																<tr key={el.id ?? k}>
																	<td>{d.nome}</td>
																	<td>{d.competicao}</td>
																	<td>{d.tipo}</td>
																	<td>{d.modalidade}</td>
																	<td>{d.escaloes}</td>
																	<td>{d.epoca}</td>
																	<td>{d.clubes}</td>
																	<td>{d.n_atletas}</td>
																	<td className="text-end">
																		<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => remover_convocatoria_associada(el.id)}>
																			{language[lang].remove ?? 'Remover'}
																		</button>
																	</td>
																</tr>
															)
														})
													) : (
														<tr>
															<td colSpan="9" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
														</tr>
													)}
												</tbody>
											</table>
										</div>
									</div>

									{/* --- Histórico da Seleção --- */}
									<div className="card mt-5">
										<div className="card-header border-0">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].historico_selecao ?? 'Histórico da Seleção'}</h3>
											</div>
										</div>
										<div className="card-body border-top p-4">
											<div className="row g-3 mb-3 align-items-end">
												<div className="col-md-2">
													<label className="form-label fw-bold fs-6">{language[lang].epoca ?? 'Época'}</label>
													<input type="text" name="epoca" value={historicoForm.epoca} placeholder="2024/2025" className="form-control rounded-0" onChange={handle_historico_form_change} />
												</div>
												<div className="col-md-2">
													<label className="form-label fw-bold fs-6">{language[lang].modalidade ?? 'Modalidade'}</label>
													<input type="text" name="modalidade" value={historicoForm.modalidade} className="form-control rounded-0" onChange={handle_historico_form_change} />
												</div>
												<div className="col-md-2">
													<label className="form-label fw-bold fs-6">{language[lang].escalao ?? 'Escalão'}</label>
													<input type="text" name="escalao" value={historicoForm.escalao} className="form-control rounded-0" onChange={handle_historico_form_change} />
												</div>
												<div className="col-md-2">
													<label className="form-label fw-bold fs-6">{language[lang].competicoes ?? 'Competições'}</label>
													<input type="text" name="competicoes" value={historicoForm.competicoes} className="form-control rounded-0" onChange={handle_historico_form_change} />
												</div>
												<div className="col-md-3">
													<label className="form-label fw-bold fs-6">{language[lang].resultados ?? 'Resultados'}</label>
													<input type="text" name="resultados" value={historicoForm.resultados} className="form-control rounded-0" onChange={handle_historico_form_change} />
												</div>
												<div className="col-md-1">
													<button type="button" className="btn btn-primary w-100" onClick={adicionar_historico}>
														<i className="bi bi-plus-lg"></i>
													</button>
												</div>
											</div>

											<table className="table table-bordered align-middle">
												<thead>
													<tr>
														<th>{language[lang].epoca ?? 'Época'}</th>
														<th>{language[lang].modalidade ?? 'Modalidade'}</th>
														<th>{language[lang].escalao ?? 'Escalão'}</th>
														<th>{language[lang].competicoes ?? 'Competições'}</th>
														<th>{language[lang].resultados ?? 'Resultados'}</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{(dados.current.info.historico || []).length > 0 ? (
														dados.current.info.historico.map((el) => (
															<tr key={el.id}>
																<td>{el.epoca}</td>
																<td>{el.modalidade}</td>
																<td>{el.escalao}</td>
																<td>{el.competicoes}</td>
																<td>{el.resultados}</td>
																<td className="text-end">
																	<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => remover_historico(el.id)}>
																		{language[lang].remove ?? 'Remover'}
																	</button>
																</td>
															</tr>
														))
													) : (
														<tr>
															<td colSpan="6" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
														</tr>
													)}
												</tbody>
											</table>
										</div>
									</div>
								</>
								)}

								{/* --- Modal: Adicionar pessoa à Equipa Técnica --- */}
								{showPersonModal && (
									<div style={modalStyles.modalOverlay} onClick={handleClosePersonModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">
													{language[lang][EQUIPA_TECNICA_CATEGORIES[personCategory]?.title_key] ?? EQUIPA_TECNICA_CATEGORIES[personCategory]?.label_key ?? 'Pesquisar'}
												</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={personSearch}
													onChange={handle_person_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedPerson?.id ?? ''}
													onChange={(e) => {
														const found = personResults.find(el => String(el.id) === String(e.target.value))
														setSelectedPerson(found ?? null)
													}}
												>
													<option value="">
														{personLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{personResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleClosePersonModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedPerson}
													onClick={adicionar_person}
												>
													{language[lang].associar_confirm ?? 'Adicionar'}
												</button>
											</div>
										</div>
									</div>
								)}

								{/* --- Modal: Inscrever Atletas --- */}
								{showAtletaModal && (
									<div style={modalStyles.modalOverlay} onClick={handleCloseAtletaModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].pesquisar_atleta ?? 'Pesquisar Atleta'}</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={atletaSearch}
													onChange={handle_atleta_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedAtletaToInscrever?.id ?? ''}
													onChange={(e) => {
														const found = atletaResults.find(el => String(el.id) === String(e.target.value))
														setSelectedAtletaToInscrever(found ?? null)
													}}
												>
													<option value="">
														{atletaLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{atletaResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleCloseAtletaModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedAtletaToInscrever}
													onClick={inscrever_atleta}
												>
													{language[lang].inscrever_atletas ?? 'Inscrever'}
												</button>
											</div>
										</div>
									</div>
								)}

								{/* --- Modal: Associar Convocatória --- */}
								{showConvocatoriaModal && (
									<div style={modalStyles.modalOverlay} onClick={handle_close_convocatoria_modal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].convocatorias_por_selecao ?? 'Convocatórias'}</label>

												<select
													className="form-select"
													size={8}
													value={selectedConvocatoria?.id ?? ''}
													onChange={(e) => {
														const found = convocatorias_disponiveis.find(el => String(el.id) === String(e.target.value))
														setSelectedConvocatoria(found ?? null)
													}}
												>
													<option value="">
														{convocatoriaLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{convocatorias_disponiveis.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handle_close_convocatoria_modal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedConvocatoria}
													onClick={associar_convocatoria}
												>
													{language[lang].associar_confirm ?? 'Associar'}
												</button>
											</div>
										</div>
									</div>
								)}

							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}>
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back ?? 'Voltar'}</span>
									</Link>
								</li>
								<li className={"nav-item " + (show_delete_button ? '' : 'd-none')}>
									<button type="button" onClick={() => apagar()} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete ?? 'Eliminar'}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save ?? 'Gravar'}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}

// Card de uma categoria da equipa técnica (Seleccionador / Treinadores / Preparadores Físicos / Fisioterapeutas / Outros)
function EquipaTecnicaCard({ category, config, items, language, lang, onAdd, onRemove }) {
	return (
		<div className="p-3 bg-white shadow-sm rounded h-100">
			<div className="d-flex justify-content-between align-items-center mb-2">
				<label className="form-label fw-bold fs-6 mb-0">{language[lang][config.title_key] ?? config.label_key}</label>
				<button type="button" className="btn btn-sm btn-primary" onClick={onAdd}>
					<i className="bi bi-plus-circle me-1"></i>
					{language[lang].add ?? 'Adicionar'}
				</button>
			</div>
			{items.length > 0 ? (
				<ul className="list-group">
					{items.map((el, k) => (
						<li key={el.id ?? k} className="list-group-item d-flex justify-content-between align-items-center">
							{el.label}
							<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => onRemove(el.id)}>
								{language[lang].remove ?? 'Remover'}
							</button>
						</li>
					))}
				</ul>
			) : (
				<div className="text-muted small">{language[lang].sem_registos ?? 'Sem registos'}</div>
			)}
		</div>
	);
}